import { type Stacklet } from '@/entities/stacklet';
import request from '@/shared/api/request';

export const restoreStackletSnapshot = (
  stacklet_id: number,
  image: number,
): Promise<{ stacklet: Stacklet }> =>
  request({
    url: `/stacklets/${stacklet_id}/`,
    method: 'POST',
    data: { image, action: 'restore' },
  });
